import * as Colors from '@nerdwallet/react-colors';
import { colors as COLORS } from '@nerdwallet/base-styles/variables';

const customColors = {
  PINKISH: '#ffe4d5',
  MUSTARD: '#ffe3a7',
  CLEMENTINE: '#ff8b5a',
  MINT: '#c4deac',
};

function getValidColor(color) {
  return (
    (color &&
      (Colors[color.toUpperCase()] ||
        customColors[color.toUpperCase()] ||
        COLORS[color.toLowerCase()])) ||
    undefined
  );
}

export default getValidColor;
